import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Shimmer from './Shimmer';

// Skeleton for /centres card grid. Mirrors the real card 1:1:
//   mint gradient banner (140px) · city eyebrow · serif name · address /
//   hours / phone lines · Get Directions + Call buttons.
// The forest-green hero (eyebrow, title, blurb) stays visible while
// loading since it's static — only the card grid shimmers.

const CentreCardShimmer = () => (
  <Box
    sx={{
      bgcolor: '#fff',
      border: '1.5px solid var(--border-l)',
      borderRadius: '20px',
      overflow: 'hidden',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {/* Mint gradient banner — no text shimmer needed, matches the real
        card which has a static emoji here. */}
    <Box
      sx={{
        height: 140,
        background: 'linear-gradient(135deg, var(--mint), var(--sage-l))',
      }}
    />
    <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', flex: 1 }}>
      {/* City eyebrow */}
      <Shimmer width={90} height={10} rounded={4} sx={{ mb: 1.25 }} />
      {/* Centre name (serif, larger) */}
      <Shimmer width="70%" height={20} rounded={4} sx={{ mb: 1.5 }} />
      {/* 3 info lines — address, hours, phone */}
      <Stack spacing={0.75} sx={{ mb: 2, flex: 1 }}>
        <Shimmer width="95%" height={12} rounded={4} />
        <Shimmer width="55%" height={12} rounded={4} />
        <Shimmer width="65%" height={12} rounded={4} />
      </Stack>
      {/* Button row */}
      <Stack direction="row" spacing={1.25}>
        <Shimmer width="100%" height={30} rounded={6} />
        <Shimmer width="100%" height={30} rounded={6} />
      </Stack>
    </Box>
  </Box>
);

const CentresShimmer = ({ count = 6 }) => (
  <Grid container spacing={{ xs: 2, md: 2.5 }}>
    {Array.from({ length: count }).map((_, i) => (
      <Grid key={i} item xs={12} sm={6} md={4}>
        <CentreCardShimmer />
      </Grid>
    ))}
  </Grid>
);

export default CentresShimmer;
